import tr from "./idiomas/es";
import Email from "./email";

class ValidadorFormulario {

    constructor(datos) {
        this.datos = datos;
        this.errores = [];
    }

    validar(politicaPrivadicadObligatoria = true) {
        if(!this.datos.nombre) {
            this.errores.push({campo: 'nombre', mensaje: 'El nombre es necesario'});
        }

        if(!this.datos.tipo_usuario) {
            this.errores.push({campo: 'tipo_usuario', mensaje: 'El tipo de usuario es necesario'});
        }

        if(!this.datos.apellidos) {
            this.errores.push({campo: 'apellidos', mensaje: 'El apellido es necesario'});
        }

        if (this.datos.tipo_usuario==='Empresa') {
            if (!this.datos.nombre_empresa) {
                this.errores.push({campo: 'nombre_empresa', mensaje: tr.errores.faltaNombreEmpresa});
            }
        }

        const validadorEmail = new Email(this.datos.email);
        if (!validadorEmail.esEmail()) {
            this.errores.push({campo: 'email', mensaje: tr.errores.formatoEmailIncorrecto});
        }

        if(!this.datos.telefono) {
            this.errores.push({campo: 'telefono', mensaje: 'El teléfono es necesario'});
        }

        if(!this.datos.importe) {
            this.errores.push({campo: 'importe', mensaje: 'El importe es necesario'});
        }

        if(isNaN(this.datos.importe)) {
            this.errores.push({campo: 'importe', mensaje: tr.errores.importeDebeSerNumero});
        }

        if(!this.datos.sexo) {
            this.errores.push({campo: 'sexo', mensaje: 'Por favor, indica el sexo'});
        }

        if (this.datos.tipo_usuario==='Empresa') {
            if(!this.datos.nombre_empresa) {
                this.errores.push({campo: 'nombre_empresa', mensaje: 'El nombre de empresa es necesario'});
            }
        }

        if (this.datos.recibo) {
            if (!this.datos.cif) {
                this.errores.push({campo: 'cif', mensaje: 'El NIF/CIF es necesario'});
            }

            if (!this.datos.direccion) {
                this.errores.push({campo: 'direccion', mensaje: tr.errores.faltaDireccion});
            }

            if (!this.datos.provincia) {
                this.errores.push({campo: 'provincia', mensaje: tr.errores.faltaProvincia});
            }

            if (!this.datos.pais) {
                this.errores.push({campo: 'pais', mensaje: tr.errores.faltaPais});
            }

            if (!this.datos.localidad) {
                this.errores.push({campo: 'localidad', mensaje: tr.errores.faltaLocalidad});
            }

            if (!this.datos.codigo_postal) {
                this.errores.push({campo: 'codigo_postal', mensaje: tr.errores.faltaCodigoPostal});
            }

        }

        if (!this.datos.privacidad && politicaPrivadicadObligatoria) {
            this.errores.push({campo: 'privacidad', mensaje: tr.errores.faltaPrivacidad});
        }

        return this.errores;
    }
}

export default ValidadorFormulario;